import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Header from "../components/header/header"
import PrivacyPolicyContent from "../components/disclaimer-pages/privacy-policy-content"
import StickyNav from "../components/sticky-nav"

const PrivacyPolicy = () => (
    <Layout>
        <Helmet>
            <body className="privacy-policy-page" />
        </Helmet>
        <SEO title="Privacy Policy" />
        <Header />
        <PrivacyPolicyContent />
        <StickyNav />
    </Layout>
)

export default PrivacyPolicy